import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ef80a90&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6ef80a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef80a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ef80a90')) {
      api.createRecord('6ef80a90', component.options)
    } else {
      api.reload('6ef80a90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ef80a90&scoped=true&", function () {
      api.rerender('6ef80a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/currencyConfig/index.vue"
export default component.exports